import type { CreateDiscordPerkPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { FormValues } from '../types'
import { getCommonPerkPayload } from './getCommonPerkPayload'

export const getCreateDiscordPerkPayload = (formValues: FormValues): CreateDiscordPerkPayload => {
  const { selectedRoles } = formValues
  const commonPayload = getCommonPerkPayload(formValues)

  const tiers = commonPayload.tiers
    .map((tier) => {
      if (selectedRoles[tier.id].length) {
        return {
          id: tier.id,
          roles: selectedRoles[tier.id].map((roleId) => ({
            id: roleId,
          })),
        }
      }

      return undefined
    })
    .filter((item): item is CreateDiscordPerkPayload['tiers'][number] => !!item)

  return {
    ...commonPayload,
    tiers,
  }
}
